import { toastr } from 'react-redux-toastr'
import { translate } from './translate'

export const notify = (title, msg, success = true) => {
  if(success) {
    toastr.success(translate(title), translate(msg))
  }
  else {
    toastr.error(translate(title), translate(msg), { timeOut: 0, extendedTimeOut: 0 })
  }
}